import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LayoutsComponent } from './layouts.component';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { environment } from 'src/environments/environment';
import { CmsContentService } from '../services/cms-content.service';
import { GenericContentNodeComponent } from './generic-content-node/generic-content-node.component';
import { IonicModule } from '@ionic/angular';
import { SwiperModule } from 'swiper/angular';

@NgModule({
  imports: [
    CommonModule,
    IonicModule.forRoot(),
    SwiperModule
  ],
  declarations: [LayoutsComponent, GenericContentNodeComponent],
  exports: [GenericContentNodeComponent],
  bootstrap: [GenericContentNodeComponent],
  providers: [CmsContentService]
})
export class LayoutsModule { }

// required for AOT compilation
export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
  // return new TranslateHttpLoader(http);
  return new TranslateHttpLoader(http, environment.HOST+'/b2c/cqt-app/assets/i18n/', '.json');
}